import { render, staticRenderFns } from "./View.vue?vue&type=template&id=1dbc7876&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dbc7876')) {
      api.createRecord('1dbc7876', component.options)
    } else {
      api.reload('1dbc7876', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=1dbc7876&", function () {
      api.rerender('1dbc7876', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Warehouse/orders/transfer/View.vue"
export default component.exports